<div style='text-align:center;padding: 1rem;'>
  <h2>{{data.heading}}</h2>
  <p>{{data.content}}</p>
  <button (click)="onClose()" style='height:30px; font-size:12px; width: 90px; border-radius:5px; border-color:#6788a3;background-color: #00569d; color:white; cursor:pointer;'>Close</button>
</div>